import { POLDA_CATS, POLDA_CAT_SHORT } from "../../lib/icons";

export const PoldaRecap = ({ rows, onOpen }) => (
  <section className="border bg-card" data-testid="polda-recap">
    <div className="px-5 py-4 border-b">
      <h2 className="font-heading font-bold text-base md:text-lg">Almatsus Ditressiber Polda</h2>
      <p className="text-xs text-muted-foreground mt-0.5">{rows.length} Polda telah mengisi data</p>
    </div>
    <div className="max-h-[420px] overflow-y-auto">
      <table className="w-full text-sm">
        <thead className="sticky top-0 bg-muted">
          <tr className="text-left border-b">
            <th className="px-5 py-2.5 eyebrow">Polda</th>
            {POLDA_CATS.map((k) => <th key={k} className="px-3 py-2.5 eyebrow text-right">{POLDA_CAT_SHORT[k]}</th>)}
            <th className="px-3 py-2.5 eyebrow text-right">Baik</th>
            <th className="px-5 py-2.5 eyebrow text-right">Rusak</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.polda} onClick={() => onOpen(r.polda)} data-testid={`polda-row-${r.polda}`}
              className="border-b last:border-0 cursor-pointer hover:bg-muted/50 transition-colors">
              <td className="px-5 py-2.5 font-medium">{r.polda}</td>
              {POLDA_CATS.map((k) => <td key={k} className="px-3 py-2.5 text-right font-mono">{r[k]}</td>)}
              <td className="px-3 py-2.5 text-right font-mono text-emerald-700">{r.baik}</td>
              <td className="px-5 py-2.5 text-right font-mono text-rose-600">{r.rusak}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </section>
);
